import QueueableRequest from './QueueableRequest';
import { bindQueryParams } from '../../helpers/url';
import { SEARCH_SUGGESTION_ENDPOINT } from '../../config/api';

export default class SearchSuggestionRequest extends QueueableRequest {
  constructor(queryParams) {
    super(bindQueryParams(SEARCH_SUGGESTION_ENDPOINT, queryParams));
  }
}
